/**
 * 1234 → "1.2k", 1_234_567 → "1.2M", 12 → "12".
 */
export function compact(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) return (n / 1000).toFixed(n < 10_000 ? 1 : 0).replace(/\.0$/, '') + 'k';
  return (n / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
}

/**
 * Форматирует TON-сумму с дробной частью. По умолчанию минимум 2, максимум 4
 * знака — так маленькие балансы вроде 0.005 TON не теряются, а круглые
 * значения 2 TON показываются как "2.00", не "2".
 */
export function formatTon(n: number, minDigits = 2, maxDigits = 4): string {
  const num = Number(n);
  if (!Number.isFinite(num)) return '0';
  return num.toLocaleString('en-US', {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: Math.max(minDigits, maxDigits),
    useGrouping: false,
  });
}

export function timeAgo(iso: string, lang: string = 'en'): string {
  const t = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - t);
  const min = 60_000;
  const hr = 60 * min;
  const day = 24 * hr;
  if (diff < min)  return lang === 'ru' ? 'только что' : 'now';
  if (diff < hr)   return Math.floor(diff / min) + (lang === 'ru' ? ' мин' : 'm');
  if (diff < day)  return Math.floor(diff / hr) + (lang === 'ru' ? ' ч' : 'h');
  return Math.floor(diff / day) + (lang === 'ru' ? ' д' : 'd');
}
